module.exports = __webpack_public_path__ + "img/grid-variant-blue.a6473f25.svg";